
export default {
  created() {
    this.$store.dispatch('setCountry')
  },
}
